import { eula_ru } from './eula_ru';

export const locale_ru = {
  ...eula_ru,
  Organization: 'Организация',
  AreYouSureRemoveMemberFromGroupParam: 'Вы действительно хотите удалить {0} участника из группы?',
  AreYouSureRemoveMembersFromGroupParam: 'Вы уверены, что хотите удалить {0} участников из группы?',
  RowsSelected: 'выбраны строки',
  AddToMembers: 'Добавить в члены',
  AssignRolesToGroup: 'Назначить роли группе',
  Confirm: 'Подтвердить',
  Name: 'Имя',
  Reset: 'Сброс',
  SaveChanges: 'Сохранить изменения',
  GeneralProperties: 'Общие свойства',
  AddMembersToGroup: 'Добавить участников в группу',
  AddMembers: 'Добавить участников',
  UnexpectedError: 'Непредвиденная ошибка',
  Confirmation: 'Подтверждение',
  DeleteMember: 'Удалить участника',
  DeleteMembers: 'Удалить участников',
  Cancel: 'Отмена',
  User: 'Пользователь',
  Search: 'Поиск',
  RemoveMember: 'Удалить участника',
  RemoveMembers: 'Удалить участников',
  PleaseSelect: 'Пожалуйста, выберите',
  Role: 'Роль',
  Scope: 'Область',
  ScopeType: 'Тип области',
  RolesAssigned: 'Назначенные роли',
  SearchScope: 'Область поиска',
  GroupParam: 'Группа {0}',
  Home: 'Дом',
  Groups: 'Группы',
  Members: 'Члены',
  Roles: 'Роли',
  AddGroup: 'Добавить группу',
  GroupInfo: 'Информация о группе',
  GroupMembers: 'Члены группы',
  CheckGroupInfoAndUsersTabs: 'Пожалуйста, проверьте информацию о группе и вкладки участников. Что-то не так',
  AddNewGroup: 'Добавить новую группу',
  PleaseEnterName: 'Пожалуйста, введите имя',
  OrganizationDatabaseHasBeenCreated: 'База данных организации создана',
  OK: 'ХОРОШО',
  SomethingWentWrong: 'Что-то пошло не так',
  OrganizationHasBeenBlocked: 'Организация заблокирована',
  OrganizationHasBeenUnblocked: 'Организация разблокирована',
  Yes: 'Да',
  No: 'Нет',
  DisplayName: 'Отображаемое имя',
  Email: 'Электронная почта',
  Address: 'Адрес',
  PleaseEnterAValidEmail: 'Пожалуйста, введите действительный адрес электронной почты',
  PleaseEnterAnAddress: 'Пожалуйста, введите адрес',
  DefaultLanguage: 'Язык по умолчанию',
  IsPartner: 'Является партнером',
  IsBlocked: 'Заблокировано',
  PartnerOrganization: 'Партнерская организация',
  Unblock: 'Разблокировать',
  Block: 'Блокировать',
  EnsureDB: 'Обеспечить БД',
  PleaseCheckTheInfoProvided: 'Пожалуйста, проверьте предоставленную информацию. Что-то не так',
  AddMembersToOrganization: 'Добавить участников в организацию',
  PleaseSelectOrRemoveRow: 'Пожалуйста, выберите или удалите строку',
  Add: 'Добавить',
  AreYouSureRemoveMemberParam: 'Вы действительно хотите удалить {0} участника из организации?',
  AreYouSureRemoveMembersParam: 'Вы действительно хотите удалить {0} участников из организации?',
  DeleteUsers: 'Удалить пользователей',
  InvitationSent: 'Приглашение отправлено',
  InvitationNotSent: 'Приглашение не отправлено',
  ResendInvitation: 'Повторно отправить приглашение',
  OrganizationMembers: 'Члены организации',
  Reload: 'Перезагрузить',
  TypeOrganizationNameToConfirm: 'Введите название организации для подтверждения',
  Type: 'Тип',
  OrganizationParam: 'Организация {0}',
  Delete: 'Удалить',
  CanNotDeleteOrgs: 'Невозможно удалить организации',
  CanNotdeleteOwnOrganization: 'Невозможно удалить собственную организацию',
  AddOrganization: 'Добавить организацию',
  CheckOrganizationInfoAndUserTabs: 'Пожалуйста, проверьте информацию об организации и вкладки пользователей. Что-то не так',
  AddNewOrganization: 'Добавить новую организацию',
  CreatingOrganizationAndItsDatabase: 'Создание организации и ее базы данных. Это может занять несколько минут. Пожалуйста, подождите',
  PleaseSelectALanguage: 'Выберите язык',
  PleaseSelectOrInvite: 'Пожалуйста, выберите или пригласите',
  SelectOrInviteOrganizationMaster: 'Выбрать или пригласить мастера организации',
  OrganizationUsers: 'Пользователи организации',
  SelectRoles: 'Выбрать роли',
  AddUser: 'Добавить пользователя',
  PartnerRoles: 'Партнерские роли',
  EditPartnerRole: 'Изменить роль партнера',
  PleaseSelectASelector: 'Выберите селектор',
  RoleName: 'Имя роли',
  RolesPermissions: 'Разрешения ролей',
  RoleIsBeingAssignedToDefaultCreatorsDelete:
    'Эта роль назначается по умолчанию создателям некоторых типов прицелов. Вы уверены, что хотите это удалить?',
  RoleDelete: 'Вы уверены, что хотите удалить эту роль?',
  DefaultRoleDelete: 'Вы уверены, что хотите удалить эту роль по умолчанию?',
  Allow: 'Разрешить',
  Deny: 'Запретить',
  Selector: 'Селектор',
  Edit: 'Редактировать',
  CreateRole: 'Создать роль',
  NewPartnerRole: 'Новая роль партнера',
  NewRole: 'Новая роль',
  EditRole: 'Изменить роль',
  PleaseSelectAnOrganization: 'Пожалуйста, выберите организацию',
  AddToGroups: 'Добавить в группы',
  AreYouSureWantRemoveUserFromGroup: 'Вы уверены, что хотите удалить пользователя из группы {0}?',
  AreYouSureWantRemoveUserFromGroups: 'Вы уверены, что хотите удалить пользователя из {0} групп?',
  DeleteGroup: 'Удалить группу',
  DeleteGroups: 'Удалить группы',
  RemoveMembership: 'Удалить членство',
  RemoveMemberships: 'Удалить членство',
  AssignRolesToUser: 'Назначить роли пользователю',
  UserParam: 'Пользователь {0}',
  CanNotDeleteOwnUser: 'Невозможно удалить собственного пользователя',
  PasswordMustMatch: 'Пароль должен совпадать"',
  AddNewUser: 'Добавить нового пользователя',
  SetPassword: 'Установить пароль',
  ConfirmPassword: 'Подтвердить пароль',
  BlankPasswordWarning:
    'Если вы оставите поле пароля пустым, система будет считать, что этот пользователь будет использовать внешнего поставщика аутентификации.',
  OrganizationsManagement: 'Управление организациями',
  UsersManagement: 'Управление пользователями',
  RolesManagement: 'Управление ролями',
  PartnerRolesManagement: 'Управление ролями партнеров',
  GroupsManagement: 'Управление группами',
  BackHome: 'Вернуться домой',
  HomeError: 'К сожалению, страница, которую вы посетили, не существует.',
  NotFound: 'Не найдено',
  ChangeOrganization: 'Изменить организацию',
  DeleteUser: 'Удалить пользователя',
  ConfirmDeleteUser: 'Вы уверены, что хотите удалить пользователя "{0}" с адресом электронной почты "{1}"?',
  UserDeleted: 'Пользователь "{0}" с адресом электронной почты "{1}" успешно удален.',

  DisplayingFilteredItems: 'Отображаются элементы, отфильтрованные по уведомлению.',
  ShowAllItems: 'Показать все элементы',
  NotificationTimestampMessageMinutes: '{0} минут назад',
  NotificationTimestampMessageHours: '{0} часов назад',
  Yesterday: 'Вчера',
  Read: 'Прочитано',
  Unread: 'Непрочитано',
  Action: 'Действие',
  AffectedElement: 'Затронутый элемент',
  LinkTo: 'Ссылка на',
  State: 'Статус',
  Date: 'Дата',
  Notifications: 'Уведомления',
  NotificationStatus: 'Статус уведомления',
  InApp: 'В приложении',
  NotificationsSettings: 'Настройки уведомлений',
  DeleteAfter: 'Удалять через',
  OneWeek: 'Одна неделя',
  OneMonth: 'Один месяц',
  OneYear: 'Один год',
  ThreeMonths: 'Три месяца',
  SixMonths: 'Шесть месяцев',
  DeleteAllNotifications: 'Удалить все',
  SurveySynchedRingNotificationDescription: 'Съемка "{A}" была синхронизирована на скважине "{B}".',
  SurveySynchedDrillholeNotificationDescription: 'Съемка "{A}" была синхронизирована на Вееп "{B}".',
  SurveySynchedQuarantineNotificationDescription: 'Съемка "{A}" была синхронизирована в карантине.',
  OrganizationCreationFinishedNotificationTitle: 'Организация создана',
  OrganizationExpirationWarningNotificationTitle: 'Срок действия организации скоро истечет',
  OrganizationCreationErrorNotificationTitle: 'Ошибка при создании организации',
  OrganizationIsAvailableNotificationTitle: 'Организация доступна',
  LicenseNeedsApprovalNotificationTitle: 'Лицензия требует одобрения',
  LicenseWasRenewedNotificationTitle: 'Лицензия была продлена',
  RingCreatedNotificationTitle: 'Вееп создан',
  SurveySynchedNotificationTitle: 'Съемка синхронизирована',
  ProjectDeletedNotificationTitle: 'Проект удален',
  ProjectEditedNotificationTitle: 'Проект изменен',
  DrillholeDeletedNotificationTitle: 'Скважина удалена',
  RingDeletedNotificationTitle: 'Вееп удален',
  DrillholeMovedNotificationTitle: 'Скважина перемещена',
  RingMovedNotificationTitle: 'Вееп перемещен',
  DrillholeEditedNotificationTitle: 'Скважина обновлена',
  RingEditedNotificationTitle: 'Вееп обновлен',
  SurveySignoffNotificationTitle: 'Запрос на подтверждение съемки',
  DrillholeCreatedNotificationTitle: 'Скважина создана',
  BulkDrillholesUpdateNotificationTitle: 'Скважины изменены',
  BulkDrillholesMovedNotificationTitle: 'Скважины перемещены',
  BulkRingsMovedNotificationTitle: 'Веепы перемещены',
  BulkDrillholesDeletedNotificationTitle: 'Скважины удалены',
  BulkRingsDeletedNotificationTitle: 'Веепы удалены',
  BulkProjectsDeletedNotificationTitle: 'Проекты удалены',
  BulkRingsCreatedNotificationTitle: 'Веепы созданы',
  BulkDrillholesCreatedNotificationTitle: 'Скважины созданы',
  SurveyDeletedNotificationTitle: 'Съемка удалена',
  SurveyDeletedNotificationDescription: 'Съемка "{A}" была удалена.',

  OrganizationCreationFinishedNotificationDescription: 'Организация {A} была создана с {X} участниками.',
  OrganizationExpirationWarningNotificationDescription: 'Срок действия организации {A} скоро истечет.',
  OrganizationCreationErrorNotificationDescription: 'Произошла ошибка при создании организации {A}.',
  OrganizationIsAvailableNotificationDescription: 'Организация {A} теперь доступна.',
  LicenseNeedsApprovalNotificationDescription: 'Лицензия с кодом инструмента {A} требует одобрения.',
  LicenseWasRenewedNotificationDescription: 'Лицензия с кодом инструмента {A} была продлена.',
  SurveySynchedNotificationDescription: 'Съемка "{A}" была синхронизирована на скважине "{B}".',
  ProjectDeletedNotificationDescription: 'Проект "{A}" был удален.',
  ProjectEditedNotificationDescription: 'Проект "{A}" был изменен.',
  DrillholeDeletedNotificationDescription: 'Скважина "{A}" была удалена.',
  RingDeletedNotificationDescription: 'Вееп "{A}" был удален.',
  DrillholeMovedNotificationDescription: 'Скважина "{B}" была перемещена в "{A}".',
  RingMovedNotificationDescription: 'Вееп "{B}" был перемещен в проект "{A}".',
  DrillholeEditedNotificationDescription: 'Скважина "{A}" была обновлена',
  RingEditedNotificationDescription: 'Вееп "{A}" был обновлен',
  SurveySignoffNotificationDescription: 'Был запрошен signoff для съемки "{A}".',
  DrillholeCreatedNotificationDescription: 'Скважина с именем "{B}" была создана в "{A}".',
  RingCreatedNotificationDescription: 'Вееп с именем "{B}" был создан в проекте "{A}".',
  BulkDrillholesUpdateNotificationDescription: '{X} скважин были изменены в "{B}".',
  BulkDrillholesMovedNotificationDescription: '{X} скважин были перемещены в "{B}".',
  BulkRingsMovedNotificationDescription: '{X} Веепов были перемещены в проект "{B}".',
  BulkDrillholesDeletedNotificationDescription: '{X} скважин были удалены',
  BulkRingsDeletedNotificationDescription: '{X} Веепов были удалены',
  BulkProjectsDeletedNotificationDescription: '{X} проектов были удалены.',
  BulkRingsCreatedNotificationDescription: '{X} Веепов были созданы.',
  BulkDrillholesCreatedNotificationDescription: '{X} скважин были созданы в "{B}".',
  ForgotPasswordNotificationTitle: 'Письмо для сброса пароля отправлено',
  OrganizationInvitationNotificationTitle: 'Получено приглашение в организацию',
  LicenseQRSharedNotificationTitle: 'С вами поделились лицензией',
  ToolUsageReportNotificationTitle: 'Отчет об использовании инструмента готов',
  OrganizationCreationFinishedNotificationTitleError: 'Ошибка при создании организации',
  OrganizationIsAvailableNotificationTitleError: 'Ошибка при активации организации',
  LicenseWasRenewedNotificationTitleError: 'Ошибка при продлении лицензии',
  RingCreatedNotificationTitleError: 'Ошибка при создании Вееп',
  SurveySynchedNotificationTitleError: 'Ошибка при синхронизации съемки',
  ProjectDeletedNotificationTitleError: 'Ошибка при удалении проекта',
  ProjectEditedNotificationTitleError: 'Ошибка при редактировании проекта',
  DrillholeDeletedNotificationTitleError: 'Ошибка при удалении скважины',
  RingDeletedNotificationTitleError: 'Ошибка при удалении Вееп',
  DrillholeMovedNotificationTitleError: 'Ошибка при перемещении скважины',
  RingMovedNotificationTitleError: 'Ошибка при перемещении Вееп',
  DrillholeEditedNotificationTitleError: 'Ошибка при обновлении скважины',
  RingEditedNotificationTitleError: 'Ошибка при обновлении Вееп',
  DrillholeCreatedNotificationTitleError: 'Ошибка при создании скважины',
  BulkDrillholesUpdateNotificationTitleError: 'Ошибка при редактировании скважин',
  BulkDrillholesMovedNotificationTitleError: 'Ошибка при перемещении скважин',
  BulkRingsMovedNotificationTitleError: 'Ошибка при перемещении Веепов',
  BulkDrillholesDeletedNotificationTitleError: 'Ошибка при удалении скважин',
  BulkRingsDeletedNotificationTitleError: 'Ошибка при удалении Веепов',
  BulkProjectsDeletedNotificationTitleError: 'Ошибка при удалении проектов',
  BulkRingsCreatedNotificationTitleError: 'Ошибка при создании Веепов',
  BulkDrillholesCreatedNotificationTitleError: 'Ошибка при создании скважин',
  SurveyDeletedNotificationTitleError: 'Ошибка при удалении съемки',
  ForgotPasswordNotificationTitleError: 'Ошибка при отправке письма для сброса пароля',
  OrganizationInvitationNotificationTitleError: 'Ошибка при отправке приглашения в организацию',
  LicenseQRSharedNotificationTitleError: 'Ошибка при предоставлении доступа к лицензии',
  ToolUsageReportNotificationTitleError: 'Ошибка при создании отчета об использовании инструмента',

  SurveyDeletedNotificationDescriptionError: 'Произошла ошибка при удалении съемки "{A}".',
  OrganizationCreationFinishedNotificationDescriptionError: 'Произошла ошибка при создании организации {A}.',
  OrganizationIsAvailableNotificationDescriptionError: 'Произошла ошибка при активации организации {A}.',
  LicenseWasRenewedNotificationDescriptionError: 'Произошла ошибка при продлении лицензии с кодом инструмента {A}.',
  SurveySynchedNotificationDescriptionError: 'Произошла ошибка при синхронизации съемки "{A}" в скважине "{B}".',
  ProjectDeletedNotificationDescriptionError: 'Произошла ошибка при удалении проекта "{A}".',
  ProjectEditedNotificationDescriptionError: 'Произошла ошибка при редактировании проекта "{A}".',
  DrillholeDeletedNotificationDescriptionError: 'Произошла ошибка при удалении скважины "{A}".',
  RingDeletedNotificationDescriptionError: 'Произошла ошибка при удалении Вееп "{A}".',
  DrillholeMovedNotificationDescriptionError: 'Произошла ошибка при перемещении скважины "{B}" в "{A}".',
  RingMovedNotificationDescriptionError: 'Произошла ошибка при перемещении Вееп "{B}" в проект "{A}".',
  DrillholeEditedNotificationDescriptionError: 'Произошла ошибка при обновлении скважины "{A}".',
  RingEditedNotificationDescriptionError: 'Произошла ошибка при обновлении Вееп "{A}".',
  DrillholeCreatedNotificationDescriptionError: 'Произошла ошибка при создании скважины "{A}" в "{B}".',
  RingCreatedNotificationDescriptionError: 'Произошла ошибка при создании Вееп "{A}" в проекте "{B}".',
  BulkDrillholesUpdateNotificationDescriptionError: 'Произошла ошибка при редактировании {X} скважин в "{B}".',
  BulkDrillholesMovedNotificationDescriptionError: 'Произошла ошибка при перемещении {X} скважин в "{A}".',
  BulkRingsMovedNotificationDescriptionError: 'Произошла ошибка при перемещении {X} Веепов в проект "{A}".',
  BulkDrillholesDeletedNotificationDescriptionError: 'Произошла ошибка при удалении {X} скважин.',
  BulkRingsDeletedNotificationDescriptionError: 'Произошла ошибка при удалении {X} Веепов.',
  BulkProjectsDeletedNotificationDescriptionError: 'Произошла ошибка при удалении {X} проектов.',
  BulkRingsCreatedNotificationDescriptionError: 'Произошла ошибка при создании {X} Веепов.',
  BulkDrillholesCreatedNotificationDescriptionError: 'Произошла ошибка при создании {X} скважин в "{B}".',
  ForgotPasswordNotificationDescriptionError: 'Произошла ошибка при отправке письма для сброса пароля.',
  OrganizationInvitationNotificationDescriptionError: 'Произошла ошибка с приглашением в организацию. Пожалуйста, проверьте данные.',
  LicenseQRSharedNotificationDescriptionError: 'Произошла ошибка при предоставлении доступа к лицензии.',
  ToolUsageReportNotificationDescriptionError: 'Произошла ошибка при создании или отправке отчета об использовании инструмента.',
  SurveySynchedRingNotificationDescriptionError: 'Произошла ошибка при синхронизации съемки "{A}" в скважине "{B}".',
  SurveySynchedDrillholeNotificationDescriptionError: 'Произошла ошибка при синхронизации съемки "{A}" в Вееп "{B}".',
  SurveySynchedQuarantineNotificationDescriptionError: 'Произошла ошибка при синхронизации съемки "{A}" в карантине.',
  IsRead: 'Прочитано',
  RelatedEntityName: 'Имя связанной сущности',
  RelatedEntityType: 'Тип связанной сущности',
  RedirectEntityName: 'Имя сущности перенаправления',
  RedirectEntityType: 'Тип сущности перенаправления',
  Count: 'Количество',
  Enable: 'Включить',
  SendNotificationsViaEmail: 'Отправлять уведомления по электронной почте',
  Title: 'Название',
  Description: 'Описание',
  TypeHeader: 'Тип',

  ForgotPasswordNotificationDescription: 'Было отправлено письмо со ссылкой для сброса пароля.',
  OrganizationInvitationNotificationDescription:
    'Вас пригласили присоединиться к организации. Пожалуйста, проверьте свою электронную почту для получения дополнительной информации.',
  LicenseQRSharedNotificationDescription:
    'С вами поделились лицензией. Пожалуйста, проверьте свою электронную почту для получения дополнительной информации.',
  ToolUsageReportNotificationDescription: 'Отчет об использовании инструмента был успешно создан и отправлен на вашу электронную почту.',

  Now: 'Сейчас',
  EmptyNotificationsTextTitle: 'Вы в курсе всех событий!',
  EmptyNotificationsTextSubtitle: 'У вас нет новых уведомлений',
  LastWeek: 'На прошлой неделе',
  Today: 'Сегодня',
  ThisWeek: 'На этой неделе',
  ThisMonth: 'В этом месяце',
  MarkAsRead: 'Отметить как прочитанное',
  MarkAsReadAll: 'Отметить как прочитанные',

  //Permissions
  //Admin
  CreatePartnerOrganization: 'Создать партнерскую организацию',
  DeletePartnerOrganization: 'Удалить партнерскую организацию',
  ManageDefaultRoles: 'Управление ролями по умолчанию',
  ManagePermissions: 'Управление разрешениями',
  //Partners
  BlockOrganization: 'Блочная организация',
  CreateOrganization: 'Создать организацию',
  DeleteOrganization: 'Удалить организацию',
  ManageLicenses: 'Управление лицензиями',
  ManageRoleAssignment: 'Управление назначениями ролей',
  //Organization
  CreateProject: 'Создать проект',
  ManageGroups: 'Управление группами',
  ManageOrganizationInfo: 'Управление информацией об организации',
  ManageOrganizationRoleAssignments: 'Управление назначениями ролей в организации',
  ManageQuarantine: 'Управление карантином',
  ManageRecycleBin: 'Управление корзиной',
  ManageRoles: 'Управление ролями',
  ManageUnitSystem: 'Управление системой единиц',
  ManageUnitSystems: 'Управление системами единиц',
  ManageUsers: 'Управление пользователями',
  //Project
  CreateDrillhole: 'Создать скважину',
  DeleteProject: 'Удалить проект',
  ManageProjectInfo: 'Управление информацией о проекте',
  ManageProjectRoleAssignments: 'Управление назначениями ролей в проекте',
  ViewProjectData: 'Просмотр данных проекта',
  //Ring
  CreateRing: 'Создать вееп',
  DeleteRing: 'Удалить вееп',
  ManageRingInfo: 'Управление информацией о вееп',
  ManageRingRoleAssignments: 'Управление назначением ролей вееп',
  ShareRing: 'Общее вееп',
  ViewRingData: 'Просмотр данных вееп',
  CreateRingDrillhole: 'Создать вееп отверстия',
  //Drillhole
  DeleteDrillhole: 'Удалить скважину',
  ManageDrillholeInfo: 'Управление информацией о скважине',
  ManageDrillholeRoleAssignments: 'Управление назначениями ролей буровой скважины',
  ViewDrillholeData: 'Просмотр данных скважины',
  ManageSurveys: 'Управление опросами',
  SynchronizeSurveys: 'Синхронизировать опросы',
  WelcomBackParam: 'С возвращением, {0}!',
  Change: 'Изменить',
  Unauthorized: 'Неавторизованный',
  YouDontHaveAccessToSite: 'У вас нет доступа к партнерскому центру',
  LoginOutInSecondsParam: 'Выход через {0} секунд',
  AssignRoleWarning:
    'Вы назначаете роли: {0} {1} на уровне организации.Роли будут применены ко всем выбранным объектам, и { 1} будет иметь разрешение на всю информацию, содержащуюся в {2}',
  UpdateExpiredRoleWarning:
    'Роли: {0} ранее были назначены пользователю {1}, но срок их действия истек. Выбранная дата заменит предыдущую дату истечения, и роли снова станут активными.',
  DoYouWantToContinue: 'Вы хотите продолжить?',
  MemberAlreadyInOrganizarion: 'Пользователь уже является членом организации {0}',
  YouHaveSelectedThisUserMoreThanOnce: 'Вы выбирали этого пользователя более одного раза',
  ClearFilter: 'Очистить фильтр',
  ElementsSussessfulyDeleted: 'Элементы успешно удалены',
  DownloadErrorsFile: 'Скачать файл с ошибками',
  Errors: 'Ошибки',
  DownloadWarningsFile: 'Скачать файл предупреждений',
  Warnings: 'Предупреждения',
  FailDeletion: 'Неудачное удаление',
  OrderBy: 'Упорядочить по',
  rowsSelected: 'выбраны строки',
  AddNew: 'Добавить новый',
  DeleteAll: 'Удалить все',
  ImportCSV: 'Импорт CSV',
  BulkUploadItems: 'Массовая загрузка элементов',
  Licenses: 'Лицензии',
  ToolCode: 'Код инструмента',
  DeviceType: 'Тип устройства',
  FromDate: 'С даты',
  UntilDate: 'До даты',
  CreatedOn: 'Создано на',
  CreatedBy: 'Сделано',
  Unlimited: 'Неограниченный',
  Coefficients: 'Коэффициенты',
  Continuous: 'Непрерывный',
  Multishot: 'Мультишот',
  Zupt: 'Зупт',
  Offline: 'Не в сети',
  Flash: 'Вспышка',
  Notes: 'Примечания',
  AddLicense: 'Добавить лицензию',
  AddNewLicense: 'Добавить новую лицензию',
  PleaseEnterToolCode: 'Пожалуйста, введите код инструмента',
  LicenseCopied: 'Лицензия скопирована в буфер обмена',
  License: 'Лицензия',
  Copy: 'Копировать',
  ErrorLoadingLicense: 'Ошибка загрузки лицензии',
  ShowLicense: 'Показать лицензию',
  LicenseAlreadyExists:
    'Вы пытаетесь создать новую лицензию для {0} №{1} с {6} по {7}, но уже существует лицензия для {0} №{1} с {2} по {3}, созданная {4} {5}. Хотите продолжить и всё равно создать новую лицензию?',
  UnlimitedLicenseAlreadyExists:
    'Безлимитная лицензия уже была создана для {0} #{1} {2} {3}. Вы хотите продолжить и создать новую лицензию в любом случае?',
  Continue: 'Продолжить',
  PeriodOfValidity: 'Срок действия',
  CopyLicense: 'Копировать лицензию',
  CopyAll: 'Копировать все',
  PleaseSelectDates: 'Пожалуйста, выберите даты',
  Project: 'Проект',
  Customer: 'Клиент',
  ExportCSV: 'Экспорт CSV',
  Reports: 'Отчеты',
  Export: 'Экспорт',
  Separator: 'Разделитель',
  Tab: 'Вкладка',
  Semicolon: 'Точка с запятой',
  Comma: 'Запятая',
  AreYouSureYouWantToDeleteSelected: 'Вы уверены, что хотите удалить выбранные элементы?',
  AreYouSureYouWantToDelete: 'Вы уверены, что хотите удалить выбранные элементы?',
  ThereWasAProblemCreatingLicense: 'При создании лицензии возникла проблема. Пожалуйста, свяжитесь с администратором.',
  ExpirationDate: 'Дата истечения срока действия',
  UpdateRoleAttributes: 'Дата истечения срока действия',
  Update: 'Обновить',
  AllowedDevices: 'Разрешенные устройства',
  RoleExpirationDate: 'Дата истечения срока действия роли',
  PleaseEnterExpirationDate: 'Пожалуйста, введите срок действия',
  MaximumLicenseDueDate: 'Максимальный срок действия лицензии',
  PleaseEnterMaxDueDate: 'Пожалуйста, введите максимальный срок действия лицензии',
  MaxLicensesPeriodInDays: 'Максимальный срок действия лицензии в днях',
  PleaseEnterMaxLicensesPeriodInDays: 'Пожалуйста, введите максимальный срок действия лицензии в днях',
  MaxNumberOfLicensesPerMonth: 'Максимальное количество лицензий в месяц',
  PleaseEnterMaxNumberOfLicensesPerMonth: 'Пожалуйста, введите максимальное количество лицензий в месяц',
  DeleteElements: 'Удалить элементы',
  DeleteItems: 'Удалить элементы',
  DeleteSelected: 'Удалить выбранное',
  DeviceTypeNotAllowed: 'Вам не разрешено создавать лицензию для этого устройства',
  MaximumLicenseDueDateReached: 'Вам не разрешено создавать лицензии со сроком действия после {0}',
  MaxLicensesPeriodInDaysReached: 'Созданные вами лицензии должны быть действительны в течение не более {0} дней.',
  MaxNumberOfLicensesPerMonthReached:
    'Вы достигли максимального количества лицензий, созданных в месяц. Пожалуйста, подождите до следующего месяца, чтобы создать новую лицензию.',
  ApprovalPending: 'Ожидание утверждения',
  InitializingOrganization: 'Инициализация организации. Пользователи скоро будут доступны',
  InvalidToolCode: 'Код инструмента должен состоять ровно из четырех цифр',
  EditRoles: 'Редактировать роли',
  EditRolesMessage: 'Редактировать роли пользователей',
  RolesWillBeRemoved: 'Следующие роли будут удалены: {0}. ',
  RolesWillBeAssigned: 'Будут назначены следующие роли: {0}. ',
  LicenseAttributesWillBeUpdated: 'Атрибуты для роли License Manager будут обновлены.',
  ThisUserIsOrganizationMaster: 'Этот пользователь уже выбран в качестве мастера организации',
  RemainingLicensesMessage: 'Всего у вас осталось {0} лицензий на этот месяц',
  MaxLicenseNumberReached: 'Вы достигли максимального количества лицензий за этот месяц',
  EULATitle: 'Лицензионное соглашение с конечным пользователем (EULA)',
  OrganizationIsExporting: 'Организация экспортируется, пожалуйста, подождите...',
  ErrorExportingOrganization: 'Произошла ошибка при экспорте организации {0}. Пожалуйста, попробуйте еще раз.',
  ExportingOrganizationSuccess: 'Процесс экспорта начался, по его завершении мы вышлем ссылку на скачивание на ваш электронный адрес.',
  CanNotDeleteOrganizationWhileExporting:
    'Организация {0} находится в процессе экспорта и не может быть удалена в данный момент. Пожалуйста, подождите и повторите попытку через некоторое время.',
  CheckingIfOrganizationExists: 'Verificando se a organização existe...',
  RestoreOrganizationConfirmDialog:
    'Эта организация уже существует, вы хотите продолжить? Все данные этой организации будут перезаписаны резервными данными.',
  ExportingProcessStarted: 'Процесс экспорта начался, загрузка начнется в ближайшее время',
  ExportOrganization: 'Экспортная организация',
  ImportOrganization: 'Организация импорта',
  UploadOrganizationBackup: 'Загрузить резервную копию организации',
  AddOrganizationFile: 'Нажмите или перетащите файл резервной копии организации в эту область для загрузки',
  ImportingOrganizationStarted: 'Процесс импорта начался',
  ImportingOrganizationSuccess: 'Процесс импорта начался, по его завершении мы отправим уведомление на вашу электронную почту',
  ErrorImportingOrganization: 'При импорте организации произошла ошибка. Пожалуйста, попробуйте еще раз',
  Importing: 'Импортирование...',
  LastImportDate: 'Последний раз эта организация была восстановлена ​​из резервной копии ',
  ShowOrganizationLicenses: 'лицензии организаций',
  ShowAll: 'Показать все',

  DefaultRolesTableError: 'Произошла ошибка при загрузке ролей по умолчанию. Пожалуйста, попробуйте еще раз.',
  GroupsTableError: 'Произошла ошибка при загрузке групп. Пожалуйста, попробуйте еще раз.',
  ErrorSavingGroupProperties: 'Произошла ошибка при сохранении свойств группы. Пожалуйста, попробуйте еще раз.',
  ErrorAddingGroupMembers: 'Произошла ошибка при добавлении членов в группу. Пожалуйста, попробуйте еще раз.',
  GroupRolesTableError: 'Произошла ошибка при загрузке ролей группы. Пожалуйста, попробуйте еще раз.',
  LicensesTableError: 'Произошла ошибка при загрузке лицензий. Пожалуйста, попробуйте еще раз.',
  OrganizationsTableError: 'Произошла ошибка при загрузке организаций. Пожалуйста, попробуйте еще раз.',
  ErrorAddingOrganizationMembers: 'Произошла ошибка при добавлении новых членов в организацию. Пожалуйста, попробуйте еще раз.',
  ErrorRemovingOrganizationMembers: 'Произошла ошибка при удалении новых членов из организации. Пожалуйста, попробуйте еще раз.',
  RoleListTableError: 'Произошла ошибка при загрузке ролей. Пожалуйста, попробуйте еще раз.',
  UsersTableError: 'Произошла ошибка при загрузке списка пользователей. Пожалуйста, попробуйте еще раз.',
  ErrorAddingGroup: 'Произошла ошибка при добавлении группы. Пожалуйста, попробуйте еще раз.',
  ErrorRemovingGroup: 'Произошла ошибка при удалении группы. Пожалуйста, попробуйте еще раз.',
  UserRolesTableError: 'Произошла ошибка при загрузке ролей пользователя. Пожалуйста, попробуйте еще раз.',
  InvitationNotSentErrorMessage: 'Произошла ошибка при отправке приглашения. Пожалуйста, попробуйте еще раз.',
  ErrorDeletingUser: 'Произошла ошибка при удалении пользователя. Пожалуйста, попробуйте еще раз.',
  PartnerRolesTableError: 'Произошла ошибка при загрузке ролей партнеров. Пожалуйста, попробуйте еще раз.',
  PaginationTotal: 'Показывает {0} элементов из {1}',
  SelectOrInviteUser: 'Выбрать или пригласить пользователя',
  SelectOrInviteUsers: 'Выбрать или пригласить пользователей',
  CheckDB: 'Проверить базу данных',
  ManageGlobalLicenses: 'Управлять глобальными лицензиями',
  ManageRoleAssignments: 'Управление назначениями ролей',
  ShareDrillhole: 'Обмен буровыми скважинами',
  SignOffSurveys: 'SignOffSurveys',
  ViewSurveyData: 'Просмотр данных исследований',
  Organizations: 'Организации',
  SelectSelector: 'Выбрать селектор',
  SelectOrganization: 'Выберите организацию',
  GroupMembership: 'Членство в группе',
  SelectEntity: 'Выберите объект',
  Users: 'Пользователи',
  AddUserToGroups: 'Добавить пользователя в группы',
  SelectLanguage: 'Выберите язык',
  English: 'English',
  Spanish: 'Español',
  Portuguese: 'Português',
  Russian: 'русский',
  French: 'Français',
  Restore: 'Restore',
  RestoreBackupConfirmMessage:
    'Хотите ли вы восстановить эту резервную копию? Все изменения, внесенные в организацию после создания резервной копии, будут потеряны',
  RestoreBackupSuccess: 'Процесс восстановления из резервной копии запущен. Когда закончите, мы отправим вам электронное письмо.',
  Backups: 'Резервные копии',
  OrganisationBackups: 'Организационное резервное копирование',
  OrganizationName: 'Название организации',
  Statistics: 'Статистика',
  Last24Hours: 'Последние 24 часа',
  Last3Days: 'Последние 3 дня',
  Last7Days: 'Последние 7 дней',
  Last28Days: 'Последние 28 дней',
  FilterByDate: 'Фильтр по дате',
  Projects: 'Проекты',
  Surveys: 'Опросы',
  ProjectsNumber: 'Количество проектов',
  UsersNumber: 'Количество пользователей',
  SurveysNumber: 'Количество опросов',
  CreationDate: 'Дата создания',
  LastUpdate: 'Дата последнего обновления',
  CustomDateRange: 'Пользовательский диапазон дат',
  OrganizationIsLocked:
    'Эта организация в настоящее время заблокирована, поскольку используется в другом процессе. Пожалуйста, подождите и повторите попытку через некоторое время.',
  SelectGroups: 'Выбрать группы',
  ErrorUpdatingRole: 'Произошла ошибка при обновлении разрешений роли. Пожалуйста, попробуйте еще раз.',
  WorkingHours: 'Рабочие часы',
  PleaseEnterWorkingHours: 'Пожалуйста, введите рабочие часы',

  Country: 'Страна',
  PleaseSelectCountry: 'Пожалуйста, выберите страну',

  // Country names
  Afghanistan: 'Афганистан',
  Albania: 'Албания',
  Algeria: 'Алжир',
  Andorra: 'Андорра',
  Angola: 'Ангола',
  'Antigua and Barbuda': 'Антигуа и Барбуда',
  Argentina: 'Аргентина',
  Armenia: 'Армения',
  Australia: 'Австралия',
  Austria: 'Австрия',
  Azerbaijan: 'Азербайджан',
  Bahamas: 'Багамские Острова',
  Bahrain: 'Бахрейн',
  Bangladesh: 'Бангладеш',
  Barbados: 'Барбадос',
  Belarus: 'Белоруссия',
  Belgium: 'Бельгия',
  Belize: 'Белиз',
  Benin: 'Бенин',
  Bhutan: 'Бутан',
  Bolivia: 'Боливия',
  'Bosnia and Herzegovina': 'Босния и Герцеговина',
  Botswana: 'Ботсвана',
  Brazil: 'Бразилия',
  Brunei: 'Бруней',
  Bulgaria: 'Болгария',
  'Burkina Faso': 'Буркина-Фасо',
  Burundi: 'Бурунди',
  Cambodia: 'Камбоджа',
  Cameroon: 'Камерун',
  Canada: 'Канада',
  'Cape Verde': 'Кабо-Верде',
  'Central African Republic': 'Центральноафриканская Республика',
  Chad: 'Чад',
  Chile: 'Чили',
  China: 'Китай',
  Colombia: 'Колумбия',
  Comoros: 'Коморские острова',
  'Costa Rica': 'Коста-Рика',
  'Côte d’Ivoire': 'Кот-д’Ивуар',
  Croatia: 'Хорватия',
  Cuba: 'Куба',
  Cyprus: 'Кипр',
  'Czech Republic': 'Чехия',
  'Democratic Republic of the Congo': 'Демократическая Республика Конго',
  Denmark: 'Дания',
  Djibouti: 'Джибути',
  Dominica: 'Доминика',
  'Dominican Republic': 'Доминиканская Республика',
  'East Timor': 'Восточный Тимор',
  Ecuador: 'Эквадор',
  Egypt: 'Египет',
  'El Salvador': 'Сальвадор',
  'Equatorial Guinea': 'Экваториальная Гвинея',
  Eritrea: 'Эритрея',
  Estonia: 'Эстония',
  Ethiopia: 'Эфиопия',
  Fiji: 'Фиджи',
  Finland: 'Финляндия',
  France: 'Франция',
  Gabon: 'Габон',
  Gambia: 'Гамбия',
  Georgia: 'Грузия',
  Germany: 'Германия',
  Ghana: 'Гана',
  Greece: 'Греция',
  Grenada: 'Гренада',
  Guatemala: 'Гватемала',
  Guinea: 'Гвинея',
  'Guinea-Bissau': 'Гвинея-Бисау',
  Guyana: 'Гайана',
  Haiti: 'Гаити',
  Honduras: 'Гондурас',
  Hungary: 'Венгрия',
  Iceland: 'Исландия',
  India: 'Индия',
  Indonesia: 'Индонезия',
  Iran: 'Иран',
  Iraq: 'Ирак',
  Ireland: 'Ирландия',
  Israel: 'Израиль',
  Italy: 'Италия',
  Jamaica: 'Ямайка',
  Japan: 'Япония',
  Jordan: 'Иордания',
  Kazakhstan: 'Казахстан',
  Kenya: 'Кения',
  Kiribati: 'Кирибати',
  Kuwait: 'Кувейт',
  Kyrgyzstan: 'Киргизия',
  Laos: 'Лаос',
  Latvia: 'Латвия',
  Lebanon: 'Ливан',
  Lesotho: 'Лесото',
  Liberia: 'Либерия',
  Libya: 'Ливия',
  Liechtenstein: 'Лихтенштейн',
  Lithuania: 'Литва',
  Luxembourg: 'Люксембург',
  Madagascar: 'Мадагаскар',
  Malawi: 'Малави',
  Malaysia: 'Малайзия',
  Maldives: 'Мальдивы',
  Mali: 'Мали',
  Malta: 'Мальта',
  'Marshall Islands': 'Маршалловы Острова',
  Mauritania: 'Мавритания',
  Mauritius: 'Маврикий',
  Mexico: 'Мексика',
  Micronesia: 'Микронезия',
  Moldova: 'Молдавия',
  Monaco: 'Монако',
  Mongolia: 'Монголия',
  Montenegro: 'Черногория',
  Morocco: 'Марокко',
  Mozambique: 'Мозамбик',
  Myanmar: 'Мьянма',
  Namibia: 'Намибия',
  Nauru: 'Науру',
  Nepal: 'Непал',
  Netherlands: 'Нидерланды',
  'New Zealand': 'Новая Зеландия',
  Nicaragua: 'Никарагуа',
  Niger: 'Нигер',
  Nigeria: 'Нигерия',
  'North Korea': 'Северная Корея',
  Norway: 'Норвегия',
  Oman: 'Оман',
  Pakistan: 'Пакистан',
  Palau: 'Палау',
  Panama: 'Панама',
  'Papua New Guinea': 'Папуа — Новая Гвинея',
  Paraguay: 'Парагвай',
  Peru: 'Перу',
  Philippines: 'Филиппины',
  Poland: 'Польша',
  Portugal: 'Португалия',
  Qatar: 'Катар',
  'Republic of the Congo': 'Республика Конго',
  'Republic of Macedonia': 'Республика Македония',
  Romania: 'Румыния',
  Russia: 'Россия',
  Rwanda: 'Руанда',
  'Saint Kitts and Nevis': 'Сент-Китс и Невис',
  'Saint Lucia': 'Сан-Марино',
  'Saint Vincent and the Grenadines': 'Сент-Винсент и Гренадины',
  Samoa: 'Самоа',
  'San Marino': 'Сан – Марино',
  'Sao Tome and Principe': 'Сан-Томе и Принсипи',
  'Saudi Arabia': 'Саудовская Аравия',
  Senegal: 'Сенегал',
  Serbia: 'Сербия',
  Seychelles: 'Сейшельские Острова',
  'Sierra Leone': 'Сьерра-Леоне',
  Singapore: 'Сингапур',
  Slovakia: 'Словакия',
  Slovenia: 'Словения',
  'Solomon Islands': 'Соломоновы Острова',
  Somalia: 'Сомали',
  'South Africa': 'ЮАР',
  'South Korea': 'Южная Корея',
  'South Sudan': 'Южный Судан',
  Spain: 'Испания',
  'Sri Lanka': 'Шри-Ланка',
  Sudan: 'Судан',
  Suriname: 'Суринам',
  Swaziland: 'Свазиленд',
  Sweden: 'Швеция',
  Switzerland: 'Швейцария',
  Syria: 'Сирия',
  Tajikistan: 'Таджикистан',
  Tanzania: 'Танзания',
  Thailand: 'Таиланд',
  Togo: 'Того',
  Tonga: 'Тонга',
  'Trinidad and Tobago': 'Тринидад и Тобаго',
  Tunisia: 'Тунис',
  Turkey: 'Турция',
  Turkmenistan: 'Туркмения',
  Tuvalu: 'Тувалу',
  Uganda: 'Уганда',
  Ukraine: 'Украина',
  'United Arab Emirates': 'Объединённые Арабские Эмираты',
  'United Kingdom': 'Великобритания',
  'United States of America': 'Соединённые Штаты Америки',
  Uruguay: 'Уругвай',
  Uzbekistan: 'Узбекистан',
  Vanuatu: 'Вануату',
  Venezuela: 'Венесуэла',
  Vietnam: 'Вьетнам',
  Yemen: 'Йемен',
  Zambia: 'Замбия',
  Zimbabwe: 'Зимбабве',

  TestOrganization: 'Тестовая организация',
  RemovalDate: 'Дата удаления',
  IsTestOrganization: 'Это тестовая организация',
  TestingEndDate: 'Дата окончания тестирования',
  TestOrgConfirmationMessage:
    'Сущность была установлена как тестовая организация и будет автоматически удалена в выбранную дату. Вы уверены, что хотите продолжить?',

  Show: 'Показать',
  Changed: 'Изменено',
  Unchanged: 'Без изменений',

  Charts: 'Графики',

  CreationChartLegend: 'Создание',
  UpdateChartLegend: 'Обновление',
  LicenseDetails: 'Детали лицензии',
  Logout: 'Выход',

  CrashError: 'Ой! Что-то пошло не так',
  SeeAllLogs: 'Пожалуйста, нажмите F12 и отправьте все журналы на вкладке «Консоль», когда будете сообщать об этом инциденте',
  ReturnHome: 'Вернуться домой',

  InvalidEmailWarning: 'Пожалуйста, выберите или введите действующий адрес электронной почты',
  CheckOrganizationInfoAndUsersTabs: 'Пожалуйста, проверьте информацию об организации и вкладки пользователей. Что-то не так',

  UserHasNoOrganizationsWarning:
    'Этот пользователь не является частью какой-либо организации. Пожалуйста, добавьте его в организацию перед назначением ролей.',

  UserHasNoOrganizationsGroupWarning:
    'Этот пользователь не является частью какой-либо организации. Пожалуйста, добавьте его в организацию перед добавлением в группы.',

  'Customer Geologist': 'Геолог клиента',
  'Drillhole Manager': 'Менеджер скважин',
  'Field Operator': 'Полевой оператор',
  Geologist: 'Геолог',
  'Global License Manager': 'Менеджер глобальных лицензий',
  'License Manager': 'Менеджер лицензий',
  'Organization Coordinator': 'Координатор организации',
  'Organization Master': 'Мастер организации',
  'Partner Administrator': 'Администратор партнера',
  'Project Manager': 'Менеджер проекта',
  'Project Viewer': 'Просмотрщик проекта',
  'Ring Manager': 'Менеджер вееп',

  Partners: 'Parceiros',

  ActiveHours: 'Активные часы',
  Active: 'Активный',
  NotActive: 'Неактивный',
  Status: 'Статус',
  Go: 'Идти',
  FilterByActiveDates: 'Фильтровать по активной дате',
  ActiveDays: 'Активные дни',

  CanCreateUnlimitedLicense: 'можно создавать бессрочные лицензии',
  CanCreateRecurrentLicenses: 'Может создавать повторяющиеся лицензии',
  Recurrence: 'Повторяемость',
  Activated: 'Активировано',
  Deactivated: 'Деактивировано',

  NeedsSignOff: 'Требуется выход',
  SelectedUserAlreadyHasTheSelectedRoles: 'У выбранного пользователя уже есть роли: {0}.',
  SelectedGroupAlreadyHasTheSelectedRoles: 'У выбранной группы уже есть роли: {0}.',

  FilterMode: 'Режим фильтрации',
  AllSelected: 'Все выбраны',
  AnyOfTheSelected: 'Любой из выбранных',
  Download: 'Скачать',

  RoleAssignmentAttributes: 'Атрибуты назначения ролей',
  LicenseManagerRoleAttributes: 'Атрибуты роли менеджера лицензий',

  'StructMaster User': 'Пользователь StructMaster',
  UseStructMaster: 'Использовать StructMaster',

  StructmasterLicenses: 'Лицензии StructMaster',
  NewStructmasterLicenseAssignment: 'Новое назначение лицензии StructMaster',
  EditStructmasterLicenseAssignment: 'Редактировать назначение лицензии StructMaster',
  SelectUser: 'Выбрать пользователя',
  UserAlreadyHasStructMasterRole: 'Ошибка: У этого пользователя уже есть роль StructMaster в этой организации',
  AddAnotherAssignment: 'Добавить еще одно назначение',
  AddRole: 'Добавить роль',
  SelectRole: 'Выбрать роль',
  PleaseSelectRole: 'Пожалуйста, выберите роль',
  DuplicatedRolesWarning: 'В вашем выборе есть повторяющиеся роли. Убедитесь, что нет дубликатов.',
  RolesWillBeUpdated: 'Будут обновлены следующие роли: {0}.',

  UserHasNoRoleWarning: 'У пользователя должна быть хотя бы одна роль в организации',

  UserWillBeAddedToOrganizationBeforeAssign:
    'Предупреждение: Пользователь "{0}" не принадлежит к организации "{1}", поэтому пользователь "{0}" будет добавлен в организацию перед назначением.',

  ManageCategories: 'Управление категориями',
  ManageGeographicInformationSystems: 'Управление геоинформационными системами',

  Appearance: 'Внешний вид',
  DarkTheme: 'Тёмная тема',
  LightTheme: 'Светлая тема',
  UseSystemTheme: 'Использовать системную тему',
  ScheduledMaintenanceText:
    'Плановое обслуживание: Облачная платформа будет проходить плановое обслуживание {0}. Сервисы могут быть прерваны на ориентировочную продолжительность {1} часов, начиная с {2}',
  MFAStatus: 'Статус многофакторной аутентификации',
  Enabled: 'Включено',
  Disabled: 'Отключено',
  EnableMFA: 'Включить многофакторную аутентификацию',
  DisableMFA: 'Отключить многофакторную аутентификацию',

  UserLimit: 'Лимит пользователей',
  PleaseEnterUserLimit: 'Пожалуйста, введите лимит пользователей',
  CheckLicenseInfoAndUsersTabs: 'Пожалуйста, проверьте информацию о лицензии и вкладки пользователей. Что-то не так',
  LicenseInfo: 'Информация о лицензии',
  AddNewStructmasterLicense: 'Добавить новую лицензию StructMaster',
  StructmasterLicense: 'Лицензия StructMaster',
  PleaseAddAtLeastOneUser: 'Пожалуйста, добавьте хотя бы одного пользователя',
  DuplicatedUserWarning: 'Этот пользователь уже выбран, пожалуйста, проверьте',
  LicenseName: 'Название лицензии',
  UserAmountExceedLimit: 'Введённое количество пользователей превышает выбранный лимит, пожалуйста, проверьте правильность данных.',

  UserAlreadyIsLicenseManagerError: 'Этот пользователь уже входит в группу администраторов лицензий. Пожалуйста, выберите другого пользователя',
  UserAlreadyIsStructmasterUserError: 'У этого пользователя уже есть роль StructMaster. Пожалуйста, выберите другого пользователя',
  DefaultGroups: 'Группы по умолчанию',
  LicenseManagerGroups: 'Группы менеджеров лицензий',
  UpdateAttributes: 'Обновить атрибуты',
  ResetLicenseAccess: 'Сбросить доступ к лицензии',

  UserOnAddGroupAlreadyIsLicenseManagerError:
    'Этот пользователь уже входит в группу администраторов лицензий, и в вашем выборе есть как минимум одна такая группа. Пожалуйста, проверьте это',
  MoreThanOneLicenseManagerGroupSelectedError:
    'В вашем выборе более одной группы администраторов лицензий, а пользователь может входить только в одну такую группу. Пожалуйста, проверьте ваш выбор.',
  Default: 'По умолчанию',

  ThereIsAlreadyAStructmasterLicenseWithThisName: 'Уже существует лицензия StructMaster с этим именем, пожалуйста, выберите другое имя.',
  ThereIsAlreadyAGroupWithThisName: 'Уже существует группа с этим именем, пожалуйста, выберите другое имя',

  GroupLogsTableError: 'Произошла ошибка при загрузке журналов аудита группы. Пожалуйста, попробуйте снова.',
  DownloadQR: 'Скачать QR',
  FilterByUser: 'Фильтровать по пользователю',

  ActiveUser: 'Активный пользователь',

  AllowAllPermissionsForThisLevel: 'Разрешить все права доступа для этого уровня',
  AllowAllAvailablePermissions: 'Разрешить все доступные права доступа',
  AllowAllAvaliablePermissionsForThisSelector: 'Разрешить все доступные права доступа для этого селектора',

  StructmasterLicensesOnlyOneActiveUserWarning:
    'Предупреждение: Для каждой лицензии StructMaster одновременно может быть активен только один пользователь.',

  SelectUsersToShare: 'Выберите пользователей для совместного доступа',
  SelectOrEnterEmailAddress: 'Выберите пользователя или введите адрес электронной почты',
  Share: 'Поделиться',
  NoUsersSelectedError: 'Пожалуйста, выберите хотя бы одного пользователя или введите адрес электронной почты',
  AddEmail: 'Добавить эл. почту',

  OrganizationUserLimitWarningCreation: 'Предупреждение: Вы можете добавить не более {0} пользователей в организацию',
  OrganizationUserLimitWarningParam:
    'Предупреждение: Вы можете добавить не более {0} пользователей в эту организацию. У вас уже {1}, поэтому вы сможете добавить только {2}.',
  OrganizationReachedUserLimit:
    'Ошибка: Эта организация уже достигла максимально допустимого количества пользователей. Пожалуйста, выберите другую организацию.',
  NewGroupUserCountErrorParam:
    'Ошибка: В этой организации максимум {0} пользователей, сейчас их {1}, и вы пытаетесь добавить ещё {2}. Пожалуйста, проверьте правильность информации.',
  TheFollowingUsersWillBeAddedToTheOrganization: 'Следующие пользователи будут добавлены в организацию:',

  UnsignedStructmasterLicenses: 'Неподписанные лицензии StructMaster',
  SaveAndSignOff: 'Сохранить и подписать',
  SignOffStructmasterLicenseWarningTitle: 'Подписать лицензию StructMaster',
  SignOffStructmasterLicenseWarningMessage:
    'Вы собираетесь утвердить создание новой лицензии StructMaster. Пользователи будут добавлены в выбранную организацию, если они еще не входят в неё, и им будет назначена роль. Вы хотите продолжить?',

  ShowOnlyUnsignedLicenses: 'Показать только лицензии, ожидающие одобрения',
  ClearFilters: 'Сбросить фильтры',
  ApproveLicenses: 'Одобрить лицензии',
  Save: 'Сохранить',

  SoftwareVersion: 'Версия программного обеспечения',
  AnErrorOcurred: 'Произошла ошибка:',
  DeleteUnsignedLicense: 'Удалить неподписанную лицензию',
  DeleteUnsignedLicenseWarning: 'Вы уверены, что хотите удалить неподписанную лицензию «{0}»?',
  SignOff: 'Утвердить',
  Refuse: 'Отказаться',

  DuplicatedRoleNameErrorCreate: 'Ошибка при создании роли: Роль с именем "{0}" уже существует в организации "{1}". Пожалуйста, введите другое имя.',
  DuplicatedRoleNameErrorUpdate:
    'Ошибка при обновлении роли: Роль с именем "{0}" уже существует в организации "{1}". Пожалуйста, введите другое имя.',
  DuplicatedDefaultRoleNameErrorUpdate:
    'Ошибка при обновлении роли: Роль по умолчанию с именем "{0}" уже существует. Пожалуйста, введите другое имя.',
  PleaseEnterAValidSearchTerm: 'Пожалуйста, введите корректный поисковый запрос',
  TextFieldLimitError: 'Поле "{0}" не должно превышать {1} символов',
  InvalidToolcode: 'Пожалуйста, введите корректный код инструмента',
  LicenseManagerGroupsMustHaveAtLeastOneRole: 'Группы менеджера лицензий должны иметь хотя бы одну роль',
  PleaseSelectAtLeastOneDeviceType: 'Пожалуйста, выберите хотя бы один тип устройства',
  Language: 'Язык',
  NoData: 'Нет данных',
  PleaseEnterCoreDiameter: 'Пожалуйста, введите диаметр керна',
  CoreDiameter: 'Диаметр керна',
  SmartCoreLicenseAlreadyExists:
    'Вы пытаетесь создать новую лицензию для {0} #{1} с диаметром инструмента "{8}" с {6} по {7}, но уже существует лицензия для {0} #{1} с диаметром инструмента "{8}" с {2} по {3}, созданная {4} {5}. Вы хотите продолжить и всё равно создать новую лицензию?',
  UnlimitedSmartCoreLicenseAlreadyExists:
    'Для {0} #{1} уже существует безлимитная лицензия с диаметром инструмента "{8}", созданная {2} {3}. Вы хотите продолжить и всё равно создать новую лицензию?',
  ToolDiameter: 'Диаметр инструмента',
  ToolcodeTooLarge: 'Код инструмента слишком большой. Он должен быть числом от 1 до 65535',
  'License Reviewer': 'Проверяющий лицензий',
  'Client Manager': 'Менеджер по работе с клиентами',
  MeasurementCount: 'Опросы',
  ToolSerialNumber: 'Серийный номер инструмента',
  ExportCsvReport: 'Экспорт отчета CSV',
  ToolType: 'Тип инструмента',
  FirstUsedOn: 'Дата первого использования',
  LastUsedOn: 'Дата последнего использования',
  ErrorGeneratingReport: 'Произошла ошибка при создании отчёта. Пожалуйста, попробуйте снова.',
  ToolUsageReport: 'Отчёт об использовании инструментов',
  ExportToolUsageReport: 'Экспорт отчёта об использовании инструментов',
  ToolUsageReportInProcess: 'Отчёт об использовании инструмента формируется. Он будет отправлен на вашу электронную почту после завершения.',
  ProjectName: 'Название проекта',
  Group: 'Группа',
  SelectOrInviteWarning: 'Пожалуйста, выберите или пригласите',
  ManagePartnerOrganization: 'Управление партнёрской организацией',
  ManageAdminOrganization: 'Управление административной организацией',
};
